import * as React from 'react';

import MarketingPlan56 from './MarketingPlan56';

export const marketingPlan56 = () => <MarketingPlan56 />;

export default {
    title: 'Illustration|MarketingPlan56',
    component: MarketingPlan56,
    parameters: {
        notes: "`import MarketingPlan56 from 'box-ui-elements/es/illustration/MarketingPlan56';`",
    },
};
